module.exports = __webpack_public_path__ + "static/media/E.d36057f3.jpg";